import { render, staticRenderFns } from "./guide-transfer.vue?vue&type=template&id=30dbbbf8"
import script from "./guide-transfer.vue?vue&type=script&lang=js"
export * from "./guide-transfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports